import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-lens-details',
  templateUrl: './lens-details.component.html',
  styleUrls: ['./lens-details.component.css', '../order.component.css'],
})
export class LensDetailsComponent implements OnInit {
  @Input() orderForm: FormGroup;
  @Output() saveOrder = new EventEmitter<{ destination: string }>();

  ngOnInit(): void {}

  onSave(destination: string): void {
    this.saveOrder.emit({ destination });
  }

  onPost(): void {
    this.onSave('POST');
  }
}
